export default __webpack_public_path__ + "static/media/BH Icons 30 p_Sea View.3f07933e.svg";